import React from "react";

import PageHeading from "2g-page-heading";

import ZadostiOdsouhlaseneWidget from "b2b/components/zadosti-odsouhlasene-widget/ZadostiOdsouhlaseneWidget";

function ZadostiOdsouhlaseneWidgetExample() {
  return (
    <>
      <PageHeading>ZadostiOdsouhlaseneWidget</PageHeading>
      <div data-testid="zadostiOdsouhlaseneWidget">
        <ZadostiOdsouhlaseneWidget />
      </div>
    </>
  );
}

export default React.memo(ZadostiOdsouhlaseneWidgetExample);
